import { destroy, get, patch, post, put } from './index';
import qs from 'qs';

export const getFolders = ({ filters, search, from, to }) => {
  return get(
    `/api/v1/folders?${qs.stringify({ search, from, to, ...filters })}`,
  );
};

export const getFolder = ({ id }) => get(`/api/v1/folders/${id}`);

export const createFolder = payload => post(`/api/v1/folders`, payload);

export const updateFolderInfo = (id, payload) =>
  patch(`/api/v1/folders/${id}`, payload);

export const deleteFolderTraveler = (folderId, travelerId) =>
  destroy(`/api/v1/folders/${folderId}/travelers/${travelerId}`);

export const addGuestsToFolder = ({ id, travelers }) =>
  post(`/api/v1/folders/${id}/travelers`, travelers);

export const updateGuestsToFolder = (id, payload) =>
  put(`/api/v1/folders/${id}/travelers`, payload);

export const getUniqueIcr = (organizationId, payload) =>
  post(
    `/api/v1/folders/getUniqueIcr?organizationId=${organizationId}`,
    payload,
  );

export const cancelAllBookings = (folderId, payload) =>
  post(`/api/v1/folders/${folderId}/bookings/cancel`, payload);

export const archiveFolder = id => post(`/api/internal/folders/${id}/archive`);

export const unarchiveFolder = id =>
  post(`/api/internal/folders/${id}/unarchive`);

export const createDefaultCostumerFile = async ({
  organizationId,
  user,
  travelers = [],
}) => {
  if (!organizationId || !user) {
    return Promise.resolve(null);
  }

  const newFolderData = await createFolder({
    name: user.lastName,
    travelers: travelers,
  });

  return newFolderData.data;
};
